import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const CalendarDayIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M12.6667 2.66671H12V1.33337h-1.3333v1.33334H5.33333V1.33337H4v1.33334h-.66667c-.74 0-1.33333.6-1.33333 1.33333v9.33336c0 .7333.59333 1.3333 1.33333 1.3333h9.33337c.7333 0 1.3333-.6 1.3333-1.3333V4.00004c0-.73333-.6-1.33333-1.3333-1.33333Zm0 10.66669H3.33333V6.66671h9.33337v6.66669Zm0-8.00003H3.33333V4.00004h9.33337v1.33333ZM4.66667 8.00004H8v3.33336H4.66667V8.00004Z" />
  </Icon>
);

export default memo(CalendarDayIcon);
